import CalculatorPurch from './CalculatorPurch.jsx';

export default CalculatorPurch;